const LOCAL_FALLBACK_ORIGIN = 'http://localhost:3000'
const LOCAL_HOST_SUFFIX = '.local'

type BrowserLocationLike = Pick<Location, 'hostname' | 'origin'> | null | undefined

export type FirebaseRuntimeEnv = {
  DEV: boolean
  VITE_FIREBASE_AUTH_EMULATOR_HOST?: string
}

const normalizeEmulatorUrl = (value: string): string => {
  if (value.startsWith('http://') || value.startsWith('https://')) return value
  return `http://${value}`
}

const isIpv4Address = (hostname: string): boolean => /^\d{1,3}(\.\d{1,3}){3}$/.test(hostname)

const isPrivateIpv4Address = (hostname: string): boolean => {
  if (!isIpv4Address(hostname)) return false

  const [first, second] = hostname.split('.').map(Number)
  if (first === 10 || first === 127) return true
  if (first === 192 && second === 168) return true
  if (first === 172 && second >= 16 && second <= 31) return true
  return false
}

export const isLocalDevelopmentHostname = (hostname: string): boolean => {
  if (hostname === 'localhost' || hostname === '::1') return true
  if (hostname.endsWith(LOCAL_HOST_SUFFIX)) return true
  return isPrivateIpv4Address(hostname)
}

const canUseAuthEmulator = (env: FirebaseRuntimeEnv, location: BrowserLocationLike): boolean => {
  if (location) return isLocalDevelopmentHostname(location.hostname)
  return env.DEV
}

export const resolveAuthEmulatorUrl = (
  env: FirebaseRuntimeEnv,
  location: BrowserLocationLike = globalThis.location
): string | null => {
  if (!canUseAuthEmulator(env, location)) return null

  const fromEnv = env.VITE_FIREBASE_AUTH_EMULATOR_HOST?.trim()
  if (fromEnv) return normalizeEmulatorUrl(fromEnv)

  const origin = location?.origin
  if (origin) return origin
  return LOCAL_FALLBACK_ORIGIN
}
